import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import ProductCard from '@/components/feature/ProductCard';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, allProducts, allArticles, faqData } from '@/mocks/data';

export default function Home() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Serenity',
    url: 'https://tsdtys5.cn',
    description: '专业女性情趣用品信息平台，提供阴蒂夹使用指南、选购推荐与科普文章。',
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Serenity - 阴蒂夹使用指南与选购推荐',
    url: 'https://tsdtys5.cn',
    description: '阴蒂夹是专为女性设计的情趣刺激玩具，通过适度夹压与震动提升敏感度与快感体验。',
    inLanguage: 'zh-CN',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '阴蒂夹使用指南与选购推荐——感官愉悦新体验',
    description: '专业阴蒂夹科普与选购平台，涵盖类型介绍、使用指南、安全须知及热门推荐。',
    url: 'https://tsdtys5.cn',
    isPartOf: { '@id': 'https://tsdtys5.cn/#website' },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const featuredProducts = allProducts.slice(0, 4);
  const latestArticles = allArticles.slice(0, 3);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20minimalist%20wellness%20lifestyle%20scene%20with%20soft%20silk%20fabric%20draped%20over%20neutral%20surfaces%20warm%20ambient%20lighting%20serene%20atmosphere%20clean%20composition%20soft%20peach%20and%20cream%20tones%20artistic%20photography&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
            alt="Serenity - 女性感官愉悦新体验"
            title="Serenity - 阴蒂夹使用指南与选购推荐"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
            <span className="inline-block bg-background-50/20 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium px-4 py-1.5 rounded-full mb-4 md:mb-6">
              探索感官愉悦新体验
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 mb-4 md:mb-6 leading-tight">
              发现专属于你的
              <br />
              <span className="text-accent-400">阴蒂夹</span>愉悦之旅
            </h1>
            <p className="text-background-200 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
              从新手入门到进阶探索，我们为你提供专业的使用指南、安全建议与精选推荐，
              帮助你找到最适合的阴蒂夹，开启安全、愉悦的感官探索之旅。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/vibration-clamps"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium px-8 py-3 rounded-full transition-all duration-300 whitespace-nowrap"
              >
                浏览全部产品 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link
                to="/article/clitoral-clamp-beginners-guide"
                className="bg-background-50/15 backdrop-blur-sm hover:bg-background-50/25 text-background-50 font-medium px-8 py-3 rounded-full transition-all duration-300 whitespace-nowrap border border-background-50/30"
              >
                新手入门指南 <i className="ri-book-open-line ml-1"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                探索阴蒂夹的多样世界
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                不同类型的阴蒂夹带来截然不同的感官体验，找到最适合你的那一款
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      title={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                      {cat.name}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                      {cat.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500">{cat.productCount} 款产品</span>
                      <span className="text-sm text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
                        查看分类 <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Products */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
                  精选热门推荐
                </h2>
                <p className="text-foreground-600 text-sm">真实用户口碑之选，品质值得信赖</p>
              </div>
              <Link
                to="/category/vibration-clamps"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredProducts.map((product) => (
                <ProductCard key={product.id} {...product} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
                  知识科普与选购指南
                </h2>
                <p className="text-foreground-600 text-sm">从入门到进阶，全面了解阴蒂夹的一切</p>
              </div>
              <Link
                to="/article/top-10-clitoral-clamps-2026"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                常见问题解答
              </h2>
              <p className="text-foreground-600 text-sm">关于阴蒂夹使用与选购的常见疑问</p>
            </div>
            <div className="space-y-3">
              {faqData.map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100 transition-colors"
                  >
                    <span className="font-medium text-foreground-800 text-sm pr-4">{faq.question}</span>
                    <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openFaqIndex === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </div>
                  </button>
                  {openFaqIndex === index && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-14 md:py-20 bg-primary-500">
          <div className="w-full max-w-3xl mx-auto px-4 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 dark:text-foreground-950 mb-4">
              准备好开启你的感官探索之旅了吗？
            </h2>
            <p className="text-primary-100 dark:text-primary-900 text-sm md:text-base mb-8 max-w-lg mx-auto">
              浏览我们的精选产品推荐，找到最适合你的那一款阴蒂夹
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/vibration-clamps"
                className="bg-background-50 hover:bg-background-100 text-primary-700 font-medium px-8 py-3 rounded-full transition-all duration-300 whitespace-nowrap"
              >
                开始选购 <i className="ri-shopping-bag-line ml-1"></i>
              </Link>
              <Link
                to="/about"
                className="bg-primary-600 hover:bg-primary-700 text-background-50 dark:text-foreground-950 font-medium px-8 py-3 rounded-full transition-all duration-300 whitespace-nowrap border border-primary-400"
              >
                了解更多 <i className="ri-information-line ml-1"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}